const settings = ({ apiUrl, userToken = '' }) => {
  return JSON.stringify({
    apiUrl: `${apiUrl}/ratings-and-reviews/v1/feedback/api`,
    accessToken: userToken, // only needed for the <trust-feedback> component (when giving a review)
  })
}

export default settings
